import React, { useState, useEffect } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useParams } from "react-router";
import AuthHeader from "../../layout/AuthHeader";
import PoweredBy from "../../layout/PoweredBy";
import Button from "../../Button";
import Container from "../../Container";
import apiRequest from "../../../services/apiRequest";
import getRoutePath from "../../../routes/getRoutePath";
import Placeholder from "../../Placeholder";
import { BrandingBg } from "../../../components/Brandingbg";

const Registration = () => {
  const intl = useIntl();
  const { token } = useParams();
  const [uid, setUid] = useState();
  const [fullName, setFullName] = useState();
  const [loading, setLoading] = useState(false);
  const [activateLoading, setActivateLoading] = useState(false);
  const [hasRevitPlugin, setHasRevitPlugin] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    apiRequest
      .post("/users/validate", { token: token }, { publicRequest: true })
      .then((data) => {
        setUid(data['id'])
        setFullName(data['firstname'] + ' ' + data['lastname']);
        setHasRevitPlugin(data['has_revit_plugin'] || false);
      })
      .catch((err) => {
        console.error("Error:", err);
        setError("Not authorized");
      })
      .finally(() => setLoading(false));
  }, [token]);

  const submit = () => {
    setActivateLoading(true);
    apiRequest
      .post("/users/activate", { token: token, uid: uid }, { publicRequest: true })
      .then(() => {window.location = getRoutePath("/login")})
      .catch((err) => {
        console.error("Error:", err);
        setError("Not authorized");
      })
      .finally(() => setLoading(false));
  }

  return (
    <BrandingBg bgOpacity={'40'}>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <Container>
          <AuthHeader
            title={intl.formatMessage({ id: "user_validation" })}
            variant="white"
          />
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
              {loading ? <Placeholder width="w-full" /> : error
                ? <FormattedMessage id="invalid_token"/>
                : <>
                  <div className="text-lg mb-6">
                    Welcome, {fullName}
                  </div>
                  <Button onClick={submit} submitting={activateLoading}>
                    {hasRevitPlugin ?
                    <FormattedMessage id="activate_user_revit"/>
  :
                    <FormattedMessage id="activate_user"/>
                    }
                  </Button>
                </>
              }
            </div>
            <div className="filter invert">
              <PoweredBy />
            </div>
          </div>
        </Container>
      </div>
    </BrandingBg>
  );
};

export default Registration;
